// extracted by mini-css-extract-plugin
export default {"root":"BcsO_V_B6oCDn9W0nqvm","info":"PHVoJ7oFpBMo2RkxmzXE","modalClose":"IQ8EG4suXKjD061dbNC6","placeHolderShimmer":"RGAh3DWO40zzmxbVLHN9"};